import * as React from "react";
import { SVGProps } from "react";
const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 14 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4 6.875H10M4 9.875H7.75M11.875 14.75H2.125C1.71079 14.75 1.375 14.4142 1.375 14V2C1.375 1.58579 1.71079 1.25 2.125 1.25H10L12.625 3.875V14C12.625 14.4142 12.2892 14.75 11.875 14.75Z"
      stroke="white"
      strokeOpacity={0.85}
      strokeWidth={1.5}
    />
  </svg>
);
export default SVGComponent;
